module.exports = __webpack_public_path__ + "static/media/login-icon.3e7b2666.svg";